import '!style-loader!css-loader!bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.min.js';
import style from './styles/app.css';
import animate from 'animate.css/animate.css';
import Phaser from 'Phaser';
import { GameWebMonetization } from './plugins/GameWebMonetization';
import BootScene from './scenes/Boot/BootScene';

// if ( navigator.userAgent.match(/Android/i) )
// {
//     const admob = require('cordova-admob/www/admob');
// }

// Lazy Load Tutorial Gifs
var $ = require( 'jquery' );
var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});
// console.log("lazyLoadInstance",lazyLoadInstance);
$("#howToPlayButton").click(function() {

    // console.log("Clicked the how to play button.");

    $('.lazy_load').each(function(){
        var img = $(this);
        img.attr('src', img.data('src'));
    });

 });

// Start Phaser Game

const phaserConfig = {
  type: Phaser.AUTO,
  backgroundColor: '#bfaf99',
  scale: {
        mode: Phaser.Scale.RESIZE,
        width: '100%',
        height: '100%'
  },
  title: 'Monarchies of Wax and Honey',
  url: 'https://monarchies.io',
  banner: {
    hidePhaser: false
  },
  physics: {
      default: 'arcade',
      arcade: {
          gravity: {
              x: 0,
              y: 0
          },
          debug: false
      }
  },
  roundPixels: true,
  scene: [BootScene]
};

class AppGame extends Phaser.Game {
  constructor(phaserConfig) {
    super(phaserConfig);
  }
}

let game = new AppGame(phaserConfig);

window.addEventListener('resize', function (event) {
    game.scale.resize(window.outerWidth, window.outerHeight);
}, false);

window.addEventListener('orientationchange', function (event) {
    setTimeout(function() {
        console.log("the orientation of the device is now " + screen.orientation.angle, window.outerWidth, window.screen.availHeight);
        game.scale.resize(window.outerWidth, window.outerHeight);
    }, 10);
}, false);

window.addEventListener('resize', function (event) {
    game.scale.resize(window.outerWidth, window.outerHeight);
}, false);

if ( navigator.userAgent.match(/Android/i) )
{
    localStorage.setItem("virtualJoystickEnabled", true);
    window.addEventListener('showkeyboard', function (event) {
        console.log("Keyboard showing.");
        game.scale.resize(window.outerWidth, window.outerHeight);
    }, false);
    window.addEventListener('hidekeyboard', function (event) {
        console.log("Keyboard hidden.");
        game.scale.resize(window.outerWidth, window.outerHeight);
    }, false);
}

// Start Web Monetization
const gameWebMonetization = new GameWebMonetization({
    paymentPointer: '$ilp.uphold.com/2ix2jgFZKeGj'
});
gameWebMonetization.start();

// Admob
// let lastAdTime = 0;
// $('#interstitialButton').click(function() { showInterstitialAd() });

document.addEventListener('deviceready', async () => {
    // Obtain user consent first

    await admob.start(); // or start loading ads

    // showInterstitialAd();

}, false);

// function showInterstitialAd() {
//     const interstitial = new admob.InterstitialAd({
//       adUnitId: 'ca-app-pub-1360350622707615/1266282034',
//     })
//     interstitial.on('dismiss', () => {
//       console.log("interstitial dismissed")
//       lastAdTime = Date.now()
//     })
//     return interstitial.load().then(() => interstitial.show()).then(() => {
//       setTimeout(() => {
//         interstitial.load().then(() => interstitial.show())
//       }, 5000)
//     })
//   }



// WEBPACK FOOTER //
// ./src/index.js